export default "__VITE_ASSET__LRw$CkVm__"